/* eslint-disable */
import * as Types from './types';

import { ServerError } from "../fetcher";

import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';
export const MissionIncidentFieldsFragmentDoc = `
    fragment MissionIncidentFields on MissionIncident {
  id
  number
  startedAt
  label
  displayStatus
  hasWorkOrders
}
    `;
export const PushInfoFieldsFragmentDoc = `
    fragment PushInfoFields on PushInfo {
  id
  accountId
  subject
  body
  createdAt
  isRead
  quality
}
    `;
export const CustomerPortalWorkOrderFieldsFragmentDoc = `
    fragment CustomerPortalWorkOrderFields on CustomerPortalWorkOrder {
  id
  number
  label
  repairDate {
    start
    end
  }
  supplier {
    id
    number
    fullName
    activity
  }
}
    `;
export const SubscribeErecoDocument = `
    mutation subscribeEreco($accountId: ID!, $customerId: ID!) {
  subscribeEreco(accountId: $accountId, customerId: $customerId)
}
    `;
export const useSubscribeErecoMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.SubscribeErecoMutation, TError, Types.SubscribeErecoMutationVariables, TContext>) =>
    useMutation<Types.SubscribeErecoMutation, TError, Types.SubscribeErecoMutationVariables, TContext>(
      ['subscribeEreco'],
      (variables?: Types.SubscribeErecoMutationVariables) => fetcher<Types.SubscribeErecoMutation, Types.SubscribeErecoMutationVariables>(SubscribeErecoDocument, variables)(),
      options
    );
useSubscribeErecoMutation.fetcher = (variables: Types.SubscribeErecoMutationVariables, options?: RequestInit['headers']) => fetcher<Types.SubscribeErecoMutation, Types.SubscribeErecoMutationVariables>(SubscribeErecoDocument, variables, options);
export const GetMeDocument = `
    query getMe {
  me {
    login
    isTemporaryLogin
    customer {
      __typename
      ... on CustomerPerson {
        firstName
        lastName
      }
      ... on CustomerCompany {
        companyName
      }
    }
  }
}
    `;
export const useGetMeQuery = <
      TData = Types.GetMeQuery,
      TError = ServerError
    >(
      variables?: Types.GetMeQueryVariables,
      options?: UseQueryOptions<Types.GetMeQuery, TError, TData>
    ) =>
    useQuery<Types.GetMeQuery, TError, TData>(
      variables === undefined ? ['getMe'] : ['getMe', variables],
      fetcher<Types.GetMeQuery, Types.GetMeQueryVariables>(GetMeDocument, variables),
      options
    );

useGetMeQuery.getKey = (variables?: Types.GetMeQueryVariables) => variables === undefined ? ['getMe'] : ['getMe', variables];
;

export const useInfiniteGetMeQuery = <
      TData = Types.GetMeQuery,
      TError = ServerError
    >(
      variables?: Types.GetMeQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetMeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetMeQuery, TError, TData>(
      variables === undefined ? ['getMe.infinite'] : ['getMe.infinite', variables],
      (metaData) => fetcher<Types.GetMeQuery, Types.GetMeQueryVariables>(GetMeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetMeQuery.getKey = (variables?: Types.GetMeQueryVariables) => variables === undefined ? ['getMe.infinite'] : ['getMe.infinite', variables];
;

useGetMeQuery.fetcher = (variables?: Types.GetMeQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetMeQuery, Types.GetMeQueryVariables>(GetMeDocument, variables, options);
export const LoginCheckDocument = `
    query LoginCheck($login: String!) {
  loginCheck(login: $login) {
    __typename
    ... on TemporaryLoginResponse {
      redirectUrl
      anonymizedEmail
      token
      agencyEmail
      agencyPhone
    }
    ... on PermanentLoginResponse {
      isLoginWithOktaEnabled
    }
  }
}
    `;
export const useLoginCheckQuery = <
      TData = Types.LoginCheckQuery,
      TError = ServerError
    >(
      variables: Types.LoginCheckQueryVariables,
      options?: UseQueryOptions<Types.LoginCheckQuery, TError, TData>
    ) =>
    useQuery<Types.LoginCheckQuery, TError, TData>(
      ['LoginCheck', variables],
      fetcher<Types.LoginCheckQuery, Types.LoginCheckQueryVariables>(LoginCheckDocument, variables),
      options
    );

useLoginCheckQuery.getKey = (variables: Types.LoginCheckQueryVariables) => ['LoginCheck', variables];
;

export const useInfiniteLoginCheckQuery = <
      TData = Types.LoginCheckQuery,
      TError = ServerError
    >(
      variables: Types.LoginCheckQueryVariables,
      options?: UseInfiniteQueryOptions<Types.LoginCheckQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.LoginCheckQuery, TError, TData>(
      ['LoginCheck.infinite', variables],
      (metaData) => fetcher<Types.LoginCheckQuery, Types.LoginCheckQueryVariables>(LoginCheckDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteLoginCheckQuery.getKey = (variables: Types.LoginCheckQueryVariables) => ['LoginCheck.infinite', variables];
;

useLoginCheckQuery.fetcher = (variables: Types.LoginCheckQueryVariables, options?: RequestInit['headers']) => fetcher<Types.LoginCheckQuery, Types.LoginCheckQueryVariables>(LoginCheckDocument, variables, options);
export const GetBrandDocument = `
    query GetBrand($code: String!) {
  brand(code: $code) {
    __typename
    ... on QueryBrandSuccess {
      data {
        id
        code
        identity {
          name
          logoUrl
        }
        dataProtectionPolicy {
          email
          url
        }
        customerPortal {
          name
          url
          displayUrl
          logoUrl
          assistance {
            phone
            hours
          }
          guides {
            userGuides {
              categoryName
              documents {
                url
                originalFilename
                mimeType
                qualities
              }
            }
            propertyTaxFillingGuide {
              url
              originalFilename
              mimeType
              qualities
            }
            trusteeCouncilGuideUrl
          }
        }
        registeredEmailService {
          name
        }
        payment {
          hasAutomaticDirectDebit
          hasOnDemandDirectDebit
        }
      }
    }
    ... on BrandNotFoundError {
      message
      code
    }
    ... on Error {
      message
    }
  }
}
    `;
export const useGetBrandQuery = <
      TData = Types.GetBrandQuery,
      TError = ServerError
    >(
      variables: Types.GetBrandQueryVariables,
      options?: UseQueryOptions<Types.GetBrandQuery, TError, TData>
    ) =>
    useQuery<Types.GetBrandQuery, TError, TData>(
      ['GetBrand', variables],
      fetcher<Types.GetBrandQuery, Types.GetBrandQueryVariables>(GetBrandDocument, variables),
      options
    );

useGetBrandQuery.getKey = (variables: Types.GetBrandQueryVariables) => ['GetBrand', variables];
;

export const useInfiniteGetBrandQuery = <
      TData = Types.GetBrandQuery,
      TError = ServerError
    >(
      variables: Types.GetBrandQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetBrandQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetBrandQuery, TError, TData>(
      ['GetBrand.infinite', variables],
      (metaData) => fetcher<Types.GetBrandQuery, Types.GetBrandQueryVariables>(GetBrandDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetBrandQuery.getKey = (variables: Types.GetBrandQueryVariables) => ['GetBrand.infinite', variables];
;

useGetBrandQuery.fetcher = (variables: Types.GetBrandQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetBrandQuery, Types.GetBrandQueryVariables>(GetBrandDocument, variables, options);
export const GetBuildingPricingsDocument = `
    query GetBuildingPricings($id: ID!, $coOwnershipMandateId: String!) {
  building(id: $id) {
    __typename
    pricings(coOwnershipMandateId: $coOwnershipMandateId) {
      codification
      amount {
        currency
        vatRate
        taxExcluded
        taxIncluded
      }
    }
  }
}
    `;
export const useGetBuildingPricingsQuery = <
      TData = Types.GetBuildingPricingsQuery,
      TError = ServerError
    >(
      variables: Types.GetBuildingPricingsQueryVariables,
      options?: UseQueryOptions<Types.GetBuildingPricingsQuery, TError, TData>
    ) =>
    useQuery<Types.GetBuildingPricingsQuery, TError, TData>(
      ['GetBuildingPricings', variables],
      fetcher<Types.GetBuildingPricingsQuery, Types.GetBuildingPricingsQueryVariables>(GetBuildingPricingsDocument, variables),
      options
    );

useGetBuildingPricingsQuery.getKey = (variables: Types.GetBuildingPricingsQueryVariables) => ['GetBuildingPricings', variables];
;

export const useInfiniteGetBuildingPricingsQuery = <
      TData = Types.GetBuildingPricingsQuery,
      TError = ServerError
    >(
      variables: Types.GetBuildingPricingsQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetBuildingPricingsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetBuildingPricingsQuery, TError, TData>(
      ['GetBuildingPricings.infinite', variables],
      (metaData) => fetcher<Types.GetBuildingPricingsQuery, Types.GetBuildingPricingsQueryVariables>(GetBuildingPricingsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetBuildingPricingsQuery.getKey = (variables: Types.GetBuildingPricingsQueryVariables) => ['GetBuildingPricings.infinite', variables];
;

useGetBuildingPricingsQuery.fetcher = (variables: Types.GetBuildingPricingsQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetBuildingPricingsQuery, Types.GetBuildingPricingsQueryVariables>(GetBuildingPricingsDocument, variables, options);
export const UpdateCustomerProfileDocument = `
    mutation updateCustomerProfile($customerId: ID!, $payload: UpdateCustomerProfileInput!) {
  updateCustomerProfile(customerId: $customerId, payload: $payload) {
    birth {
      date
    }
    email
    familyStatus
    landlinePhone
    mobilePhone
  }
}
    `;
export const useUpdateCustomerProfileMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.UpdateCustomerProfileMutation, TError, Types.UpdateCustomerProfileMutationVariables, TContext>) =>
    useMutation<Types.UpdateCustomerProfileMutation, TError, Types.UpdateCustomerProfileMutationVariables, TContext>(
      ['updateCustomerProfile'],
      (variables?: Types.UpdateCustomerProfileMutationVariables) => fetcher<Types.UpdateCustomerProfileMutation, Types.UpdateCustomerProfileMutationVariables>(UpdateCustomerProfileDocument, variables)(),
      options
    );
useUpdateCustomerProfileMutation.fetcher = (variables: Types.UpdateCustomerProfileMutationVariables, options?: RequestInit['headers']) => fetcher<Types.UpdateCustomerProfileMutation, Types.UpdateCustomerProfileMutationVariables>(UpdateCustomerProfileDocument, variables, options);
export const GetInsuranceCompaniesDocument = `
    query GetInsuranceCompanies {
  insuranceCompanies
}
    `;
export const useGetInsuranceCompaniesQuery = <
      TData = Types.GetInsuranceCompaniesQuery,
      TError = ServerError
    >(
      variables?: Types.GetInsuranceCompaniesQueryVariables,
      options?: UseQueryOptions<Types.GetInsuranceCompaniesQuery, TError, TData>
    ) =>
    useQuery<Types.GetInsuranceCompaniesQuery, TError, TData>(
      variables === undefined ? ['GetInsuranceCompanies'] : ['GetInsuranceCompanies', variables],
      fetcher<Types.GetInsuranceCompaniesQuery, Types.GetInsuranceCompaniesQueryVariables>(GetInsuranceCompaniesDocument, variables),
      options
    );

useGetInsuranceCompaniesQuery.getKey = (variables?: Types.GetInsuranceCompaniesQueryVariables) => variables === undefined ? ['GetInsuranceCompanies'] : ['GetInsuranceCompanies', variables];
;

export const useInfiniteGetInsuranceCompaniesQuery = <
      TData = Types.GetInsuranceCompaniesQuery,
      TError = ServerError
    >(
      variables?: Types.GetInsuranceCompaniesQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetInsuranceCompaniesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetInsuranceCompaniesQuery, TError, TData>(
      variables === undefined ? ['GetInsuranceCompanies.infinite'] : ['GetInsuranceCompanies.infinite', variables],
      (metaData) => fetcher<Types.GetInsuranceCompaniesQuery, Types.GetInsuranceCompaniesQueryVariables>(GetInsuranceCompaniesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetInsuranceCompaniesQuery.getKey = (variables?: Types.GetInsuranceCompaniesQueryVariables) => variables === undefined ? ['GetInsuranceCompanies.infinite'] : ['GetInsuranceCompanies.infinite', variables];
;

useGetInsuranceCompaniesQuery.fetcher = (variables?: Types.GetInsuranceCompaniesQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetInsuranceCompaniesQuery, Types.GetInsuranceCompaniesQueryVariables>(GetInsuranceCompaniesDocument, variables, options);
export const UpdateHeatingCertificateDocument = `
    mutation updateHeatingCertificate($customerId: ID!, $heatingCertificate: UpdateLeaseHeatingCertificateInput!) {
  updateHeatingCertificate(
    customerId: $customerId
    heatingCertificate: $heatingCertificate
  )
}
    `;
export const useUpdateHeatingCertificateMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.UpdateHeatingCertificateMutation, TError, Types.UpdateHeatingCertificateMutationVariables, TContext>) =>
    useMutation<Types.UpdateHeatingCertificateMutation, TError, Types.UpdateHeatingCertificateMutationVariables, TContext>(
      ['updateHeatingCertificate'],
      (variables?: Types.UpdateHeatingCertificateMutationVariables) => fetcher<Types.UpdateHeatingCertificateMutation, Types.UpdateHeatingCertificateMutationVariables>(UpdateHeatingCertificateDocument, variables)(),
      options
    );
useUpdateHeatingCertificateMutation.fetcher = (variables: Types.UpdateHeatingCertificateMutationVariables, options?: RequestInit['headers']) => fetcher<Types.UpdateHeatingCertificateMutation, Types.UpdateHeatingCertificateMutationVariables>(UpdateHeatingCertificateDocument, variables, options);
export const UpdateInsuranceMultiriskUnitDocument = `
    mutation updateInsuranceMultiriskUnit($customerId: ID!, $insuranceMultiriskUnit: UpdateLeaseInsuranceMultiriskUnitInput!) {
  updateInsuranceMultiriskUnit(
    customerId: $customerId
    insuranceMultiriskUnit: $insuranceMultiriskUnit
  )
}
    `;
export const useUpdateInsuranceMultiriskUnitMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.UpdateInsuranceMultiriskUnitMutation, TError, Types.UpdateInsuranceMultiriskUnitMutationVariables, TContext>) =>
    useMutation<Types.UpdateInsuranceMultiriskUnitMutation, TError, Types.UpdateInsuranceMultiriskUnitMutationVariables, TContext>(
      ['updateInsuranceMultiriskUnit'],
      (variables?: Types.UpdateInsuranceMultiriskUnitMutationVariables) => fetcher<Types.UpdateInsuranceMultiriskUnitMutation, Types.UpdateInsuranceMultiriskUnitMutationVariables>(UpdateInsuranceMultiriskUnitDocument, variables)(),
      options
    );
useUpdateInsuranceMultiriskUnitMutation.fetcher = (variables: Types.UpdateInsuranceMultiriskUnitMutationVariables, options?: RequestInit['headers']) => fetcher<Types.UpdateInsuranceMultiriskUnitMutation, Types.UpdateInsuranceMultiriskUnitMutationVariables>(UpdateInsuranceMultiriskUnitDocument, variables, options);
export const CreateExpenseRegularizationDocument = `
    mutation createExpenseRegularization($customerId: ID!, $expenseRegularization: CreateExpenseRegularizationInput!) {
  createExpenseRegularization(
    customerId: $customerId
    expenseRegularization: $expenseRegularization
  ) {
    __typename
    ... on MutationCreateExpenseRegularizationSuccess {
      data {
        id
      }
    }
    ... on CreateExpenseRegularizationRejectedError {
      message
      status
      code
    }
  }
}
    `;
export const useCreateExpenseRegularizationMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.CreateExpenseRegularizationMutation, TError, Types.CreateExpenseRegularizationMutationVariables, TContext>) =>
    useMutation<Types.CreateExpenseRegularizationMutation, TError, Types.CreateExpenseRegularizationMutationVariables, TContext>(
      ['createExpenseRegularization'],
      (variables?: Types.CreateExpenseRegularizationMutationVariables) => fetcher<Types.CreateExpenseRegularizationMutation, Types.CreateExpenseRegularizationMutationVariables>(CreateExpenseRegularizationDocument, variables)(),
      options
    );
useCreateExpenseRegularizationMutation.fetcher = (variables: Types.CreateExpenseRegularizationMutationVariables, options?: RequestInit['headers']) => fetcher<Types.CreateExpenseRegularizationMutation, Types.CreateExpenseRegularizationMutationVariables>(CreateExpenseRegularizationDocument, variables, options);
export const GetExpenseRegularizationEligibilityDocument = `
    query GetExpenseRegularizationEligibility($accountId: ID!) {
  account(id: $accountId) {
    id
    ... on LessorAccount {
      externalExpenseRegularization {
        isEligible
        eligibleBuildingIds
        hasExternalTrusteeBuildings
        isBannerEligible
      }
    }
  }
}
    `;
export const useGetExpenseRegularizationEligibilityQuery = <
      TData = Types.GetExpenseRegularizationEligibilityQuery,
      TError = ServerError
    >(
      variables: Types.GetExpenseRegularizationEligibilityQueryVariables,
      options?: UseQueryOptions<Types.GetExpenseRegularizationEligibilityQuery, TError, TData>
    ) =>
    useQuery<Types.GetExpenseRegularizationEligibilityQuery, TError, TData>(
      ['GetExpenseRegularizationEligibility', variables],
      fetcher<Types.GetExpenseRegularizationEligibilityQuery, Types.GetExpenseRegularizationEligibilityQueryVariables>(GetExpenseRegularizationEligibilityDocument, variables),
      options
    );

useGetExpenseRegularizationEligibilityQuery.getKey = (variables: Types.GetExpenseRegularizationEligibilityQueryVariables) => ['GetExpenseRegularizationEligibility', variables];
;

export const useInfiniteGetExpenseRegularizationEligibilityQuery = <
      TData = Types.GetExpenseRegularizationEligibilityQuery,
      TError = ServerError
    >(
      variables: Types.GetExpenseRegularizationEligibilityQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetExpenseRegularizationEligibilityQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetExpenseRegularizationEligibilityQuery, TError, TData>(
      ['GetExpenseRegularizationEligibility.infinite', variables],
      (metaData) => fetcher<Types.GetExpenseRegularizationEligibilityQuery, Types.GetExpenseRegularizationEligibilityQueryVariables>(GetExpenseRegularizationEligibilityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetExpenseRegularizationEligibilityQuery.getKey = (variables: Types.GetExpenseRegularizationEligibilityQueryVariables) => ['GetExpenseRegularizationEligibility.infinite', variables];
;

useGetExpenseRegularizationEligibilityQuery.fetcher = (variables: Types.GetExpenseRegularizationEligibilityQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetExpenseRegularizationEligibilityQuery, Types.GetExpenseRegularizationEligibilityQueryVariables>(GetExpenseRegularizationEligibilityDocument, variables, options);
export const GetLeasesDocument = `
    query GetLeases($filters: LeasesFiltersInput!, $cursor: CursorInput) {
  leases(filters: $filters, cursor: $cursor) {
    edges {
      node {
        id
        entryDate
        leaveDate
        tenants {
          isMain
          customer {
            id
            ... on CustomerPerson {
              lastName
              firstName
            }
            ... on CustomerCompany {
              companyName
            }
          }
        }
        units {
          isMain
          unit {
            coOwnershipBylawsId
            ... on UnitHousing {
              subType
            }
            ... on UnitApartment {
              subType
            }
            ... on UnitParking {
              category
            }
            ... on UnitProfessionalRetailer {
              category
            }
            ... on UnitLand {
              category
            }
            ... on UnitOther {
              category
            }
            ... on UnitIslet {
              category
            }
          }
        }
        building {
          address {
            address1
            zipCode
            city
            country
          }
        }
        tenantBalance {
          value
          currency
        }
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;
export const useGetLeasesQuery = <
      TData = Types.GetLeasesQuery,
      TError = ServerError
    >(
      variables: Types.GetLeasesQueryVariables,
      options?: UseQueryOptions<Types.GetLeasesQuery, TError, TData>
    ) =>
    useQuery<Types.GetLeasesQuery, TError, TData>(
      ['GetLeases', variables],
      fetcher<Types.GetLeasesQuery, Types.GetLeasesQueryVariables>(GetLeasesDocument, variables),
      options
    );

useGetLeasesQuery.getKey = (variables: Types.GetLeasesQueryVariables) => ['GetLeases', variables];
;

export const useInfiniteGetLeasesQuery = <
      TData = Types.GetLeasesQuery,
      TError = ServerError
    >(
      variables: Types.GetLeasesQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetLeasesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetLeasesQuery, TError, TData>(
      ['GetLeases.infinite', variables],
      (metaData) => fetcher<Types.GetLeasesQuery, Types.GetLeasesQueryVariables>(GetLeasesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetLeasesQuery.getKey = (variables: Types.GetLeasesQueryVariables) => ['GetLeases.infinite', variables];
;

useGetLeasesQuery.fetcher = (variables: Types.GetLeasesQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetLeasesQuery, Types.GetLeasesQueryVariables>(GetLeasesDocument, variables, options);
export const GetRentalSituationFileDocument = `
    query GetRentalSituationFile($lessorAccountId: ID!) {
  rentalSituationFile(lessorAccountId: $lessorAccountId) {
    fileId
  }
}
    `;
export const useGetRentalSituationFileQuery = <
      TData = Types.GetRentalSituationFileQuery,
      TError = ServerError
    >(
      variables: Types.GetRentalSituationFileQueryVariables,
      options?: UseQueryOptions<Types.GetRentalSituationFileQuery, TError, TData>
    ) =>
    useQuery<Types.GetRentalSituationFileQuery, TError, TData>(
      ['GetRentalSituationFile', variables],
      fetcher<Types.GetRentalSituationFileQuery, Types.GetRentalSituationFileQueryVariables>(GetRentalSituationFileDocument, variables),
      options
    );

useGetRentalSituationFileQuery.getKey = (variables: Types.GetRentalSituationFileQueryVariables) => ['GetRentalSituationFile', variables];
;

export const useInfiniteGetRentalSituationFileQuery = <
      TData = Types.GetRentalSituationFileQuery,
      TError = ServerError
    >(
      variables: Types.GetRentalSituationFileQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetRentalSituationFileQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetRentalSituationFileQuery, TError, TData>(
      ['GetRentalSituationFile.infinite', variables],
      (metaData) => fetcher<Types.GetRentalSituationFileQuery, Types.GetRentalSituationFileQueryVariables>(GetRentalSituationFileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetRentalSituationFileQuery.getKey = (variables: Types.GetRentalSituationFileQueryVariables) => ['GetRentalSituationFile.infinite', variables];
;

useGetRentalSituationFileQuery.fetcher = (variables: Types.GetRentalSituationFileQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetRentalSituationFileQuery, Types.GetRentalSituationFileQueryVariables>(GetRentalSituationFileDocument, variables, options);
export const GetMissionIncidentsDocument = `
    query GetMissionIncidents($id: ID!, $cursor: CursorInput, $sortBy: [MissionIncidentSortInput!], $filters: MissionIncidentFiltersInput) {
  account(id: $id) {
    id
    ... on CoOwnerAccount {
      missionIncidents(cursor: $cursor, sortBy: $sortBy, filters: $filters) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...MissionIncidentFields
          }
        }
      }
    }
    ... on TenantAccount {
      missionIncidents(cursor: $cursor, sortBy: $sortBy, filters: $filters) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...MissionIncidentFields
          }
        }
      }
    }
    ... on LessorAccount {
      missionIncidents(cursor: $cursor, sortBy: $sortBy, filters: $filters) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...MissionIncidentFields
          }
        }
      }
    }
  }
}
    ${MissionIncidentFieldsFragmentDoc}`;
export const useGetMissionIncidentsQuery = <
      TData = Types.GetMissionIncidentsQuery,
      TError = ServerError
    >(
      variables: Types.GetMissionIncidentsQueryVariables,
      options?: UseQueryOptions<Types.GetMissionIncidentsQuery, TError, TData>
    ) =>
    useQuery<Types.GetMissionIncidentsQuery, TError, TData>(
      ['GetMissionIncidents', variables],
      fetcher<Types.GetMissionIncidentsQuery, Types.GetMissionIncidentsQueryVariables>(GetMissionIncidentsDocument, variables),
      options
    );

useGetMissionIncidentsQuery.getKey = (variables: Types.GetMissionIncidentsQueryVariables) => ['GetMissionIncidents', variables];
;

export const useInfiniteGetMissionIncidentsQuery = <
      TData = Types.GetMissionIncidentsQuery,
      TError = ServerError
    >(
      variables: Types.GetMissionIncidentsQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetMissionIncidentsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetMissionIncidentsQuery, TError, TData>(
      ['GetMissionIncidents.infinite', variables],
      (metaData) => fetcher<Types.GetMissionIncidentsQuery, Types.GetMissionIncidentsQueryVariables>(GetMissionIncidentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetMissionIncidentsQuery.getKey = (variables: Types.GetMissionIncidentsQueryVariables) => ['GetMissionIncidents.infinite', variables];
;

useGetMissionIncidentsQuery.fetcher = (variables: Types.GetMissionIncidentsQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetMissionIncidentsQuery, Types.GetMissionIncidentsQueryVariables>(GetMissionIncidentsDocument, variables, options);
export const GetSaleAgreementWithdrawalFormDocument = `
    query GetSaleAgreementWithdrawalForm($id: ID!, $workflow: String) {
  account(id: $id) {
    id
    ... on CoOwnerAccount {
      saleAgreementWithdrawalForm(workflow: $workflow) {
        ... on SaleAgreementWithdrawalFormAcceptedResult {
          workflow
        }
        ... on SaleAgreementWithdrawalFormResult {
          url
        }
      }
    }
  }
}
    `;
export const useGetSaleAgreementWithdrawalFormQuery = <
      TData = Types.GetSaleAgreementWithdrawalFormQuery,
      TError = ServerError
    >(
      variables: Types.GetSaleAgreementWithdrawalFormQueryVariables,
      options?: UseQueryOptions<Types.GetSaleAgreementWithdrawalFormQuery, TError, TData>
    ) =>
    useQuery<Types.GetSaleAgreementWithdrawalFormQuery, TError, TData>(
      ['GetSaleAgreementWithdrawalForm', variables],
      fetcher<Types.GetSaleAgreementWithdrawalFormQuery, Types.GetSaleAgreementWithdrawalFormQueryVariables>(GetSaleAgreementWithdrawalFormDocument, variables),
      options
    );

useGetSaleAgreementWithdrawalFormQuery.getKey = (variables: Types.GetSaleAgreementWithdrawalFormQueryVariables) => ['GetSaleAgreementWithdrawalForm', variables];
;

export const useInfiniteGetSaleAgreementWithdrawalFormQuery = <
      TData = Types.GetSaleAgreementWithdrawalFormQuery,
      TError = ServerError
    >(
      variables: Types.GetSaleAgreementWithdrawalFormQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetSaleAgreementWithdrawalFormQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetSaleAgreementWithdrawalFormQuery, TError, TData>(
      ['GetSaleAgreementWithdrawalForm.infinite', variables],
      (metaData) => fetcher<Types.GetSaleAgreementWithdrawalFormQuery, Types.GetSaleAgreementWithdrawalFormQueryVariables>(GetSaleAgreementWithdrawalFormDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetSaleAgreementWithdrawalFormQuery.getKey = (variables: Types.GetSaleAgreementWithdrawalFormQueryVariables) => ['GetSaleAgreementWithdrawalForm.infinite', variables];
;

useGetSaleAgreementWithdrawalFormQuery.fetcher = (variables: Types.GetSaleAgreementWithdrawalFormQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetSaleAgreementWithdrawalFormQuery, Types.GetSaleAgreementWithdrawalFormQueryVariables>(GetSaleAgreementWithdrawalFormDocument, variables, options);
export const GetWorkOrdersDocument = `
    query GetWorkOrders($missionId: ID!, $accountId: ID!, $cursor: CursorInput) {
  workOrders(missionId: $missionId, accountId: $accountId, cursor: $cursor) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...CustomerPortalWorkOrderFields
      }
    }
  }
}
    ${CustomerPortalWorkOrderFieldsFragmentDoc}`;
export const useGetWorkOrdersQuery = <
      TData = Types.GetWorkOrdersQuery,
      TError = ServerError
    >(
      variables: Types.GetWorkOrdersQueryVariables,
      options?: UseQueryOptions<Types.GetWorkOrdersQuery, TError, TData>
    ) =>
    useQuery<Types.GetWorkOrdersQuery, TError, TData>(
      ['GetWorkOrders', variables],
      fetcher<Types.GetWorkOrdersQuery, Types.GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, variables),
      options
    );

useGetWorkOrdersQuery.getKey = (variables: Types.GetWorkOrdersQueryVariables) => ['GetWorkOrders', variables];
;

export const useInfiniteGetWorkOrdersQuery = <
      TData = Types.GetWorkOrdersQuery,
      TError = ServerError
    >(
      variables: Types.GetWorkOrdersQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetWorkOrdersQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetWorkOrdersQuery, TError, TData>(
      ['GetWorkOrders.infinite', variables],
      (metaData) => fetcher<Types.GetWorkOrdersQuery, Types.GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetWorkOrdersQuery.getKey = (variables: Types.GetWorkOrdersQueryVariables) => ['GetWorkOrders.infinite', variables];
;

useGetWorkOrdersQuery.fetcher = (variables: Types.GetWorkOrdersQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetWorkOrdersQuery, Types.GetWorkOrdersQueryVariables>(GetWorkOrdersDocument, variables, options);
export const RequestSaleAgreementWithdrawalDocument = `
    mutation requestSaleAgreementWithdrawal($input: RequestSaleAgreementWithdrawalInput!) {
  requestSaleAgreementWithdrawal(input: $input) {
    __typename
    ... on MutationRequestSaleAgreementWithdrawalSuccess {
      data {
        requestedAt
      }
    }
    ... on SaleAgreementNotWithdrawableError {
      message
    }
    ... on SaleAgreementAlreadyWithdrawnError {
      message
    }
    ... on SaleAgreementNotFoundError {
      message
    }
    ... on SaleAgreementWithdrawalForbiddenError {
      message
    }
  }
}
    `;
export const useRequestSaleAgreementWithdrawalMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.RequestSaleAgreementWithdrawalMutation, TError, Types.RequestSaleAgreementWithdrawalMutationVariables, TContext>) =>
    useMutation<Types.RequestSaleAgreementWithdrawalMutation, TError, Types.RequestSaleAgreementWithdrawalMutationVariables, TContext>(
      ['requestSaleAgreementWithdrawal'],
      (variables?: Types.RequestSaleAgreementWithdrawalMutationVariables) => fetcher<Types.RequestSaleAgreementWithdrawalMutation, Types.RequestSaleAgreementWithdrawalMutationVariables>(RequestSaleAgreementWithdrawalDocument, variables)(),
      options
    );
useRequestSaleAgreementWithdrawalMutation.fetcher = (variables: Types.RequestSaleAgreementWithdrawalMutationVariables, options?: RequestInit['headers']) => fetcher<Types.RequestSaleAgreementWithdrawalMutation, Types.RequestSaleAgreementWithdrawalMutationVariables>(RequestSaleAgreementWithdrawalDocument, variables, options);
export const CreatePostalVoteDraftDocument = `
    mutation CreatePostalVoteDraft($coOwnerAccountId: ID!, $generalAssemblyId: ID!, $votes: [ResolutionVoteInput!]!) {
  createPostalVoteDraft(
    coOwnerAccountId: $coOwnerAccountId
    generalAssemblyId: $generalAssemblyId
    votes: $votes
  ) {
    id
    coOwnerAccountId
    generalAssemblyId
    votes {
      id
      status
      resolutionId
      candidate
      isSecondVote
    }
  }
}
    `;
export const useCreatePostalVoteDraftMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.CreatePostalVoteDraftMutation, TError, Types.CreatePostalVoteDraftMutationVariables, TContext>) =>
    useMutation<Types.CreatePostalVoteDraftMutation, TError, Types.CreatePostalVoteDraftMutationVariables, TContext>(
      ['CreatePostalVoteDraft'],
      (variables?: Types.CreatePostalVoteDraftMutationVariables) => fetcher<Types.CreatePostalVoteDraftMutation, Types.CreatePostalVoteDraftMutationVariables>(CreatePostalVoteDraftDocument, variables)(),
      options
    );
useCreatePostalVoteDraftMutation.fetcher = (variables: Types.CreatePostalVoteDraftMutationVariables, options?: RequestInit['headers']) => fetcher<Types.CreatePostalVoteDraftMutation, Types.CreatePostalVoteDraftMutationVariables>(CreatePostalVoteDraftDocument, variables, options);
export const GetPostalVoteSignatureDocument = `
    query GetPostalVoteSignature($generalAssemblyId: ID!) {
  postalVoteSignature(missionId: $generalAssemblyId) {
    signUrl
    transactionId
  }
}
    `;
export const useGetPostalVoteSignatureQuery = <
      TData = Types.GetPostalVoteSignatureQuery,
      TError = ServerError
    >(
      variables: Types.GetPostalVoteSignatureQueryVariables,
      options?: UseQueryOptions<Types.GetPostalVoteSignatureQuery, TError, TData>
    ) =>
    useQuery<Types.GetPostalVoteSignatureQuery, TError, TData>(
      ['GetPostalVoteSignature', variables],
      fetcher<Types.GetPostalVoteSignatureQuery, Types.GetPostalVoteSignatureQueryVariables>(GetPostalVoteSignatureDocument, variables),
      options
    );

useGetPostalVoteSignatureQuery.getKey = (variables: Types.GetPostalVoteSignatureQueryVariables) => ['GetPostalVoteSignature', variables];
;

export const useInfiniteGetPostalVoteSignatureQuery = <
      TData = Types.GetPostalVoteSignatureQuery,
      TError = ServerError
    >(
      variables: Types.GetPostalVoteSignatureQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetPostalVoteSignatureQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetPostalVoteSignatureQuery, TError, TData>(
      ['GetPostalVoteSignature.infinite', variables],
      (metaData) => fetcher<Types.GetPostalVoteSignatureQuery, Types.GetPostalVoteSignatureQueryVariables>(GetPostalVoteSignatureDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetPostalVoteSignatureQuery.getKey = (variables: Types.GetPostalVoteSignatureQueryVariables) => ['GetPostalVoteSignature.infinite', variables];
;

useGetPostalVoteSignatureQuery.fetcher = (variables: Types.GetPostalVoteSignatureQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetPostalVoteSignatureQuery, Types.GetPostalVoteSignatureQueryVariables>(GetPostalVoteSignatureDocument, variables, options);
export const StartPostalVoteSignatureDocument = `
    mutation StartPostalVoteSignature($coOwnerAccountId: ID!, $customerId: ID!, $generalAssemblyId: ID!, $brandCode: String!) {
  startPostalVoteSignature(
    coOwnerAccountId: $coOwnerAccountId
    customerId: $customerId
    generalAssemblyId: $generalAssemblyId
    brandCode: $brandCode
  )
}
    `;
export const useStartPostalVoteSignatureMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.StartPostalVoteSignatureMutation, TError, Types.StartPostalVoteSignatureMutationVariables, TContext>) =>
    useMutation<Types.StartPostalVoteSignatureMutation, TError, Types.StartPostalVoteSignatureMutationVariables, TContext>(
      ['StartPostalVoteSignature'],
      (variables?: Types.StartPostalVoteSignatureMutationVariables) => fetcher<Types.StartPostalVoteSignatureMutation, Types.StartPostalVoteSignatureMutationVariables>(StartPostalVoteSignatureDocument, variables)(),
      options
    );
useStartPostalVoteSignatureMutation.fetcher = (variables: Types.StartPostalVoteSignatureMutationVariables, options?: RequestInit['headers']) => fetcher<Types.StartPostalVoteSignatureMutation, Types.StartPostalVoteSignatureMutationVariables>(StartPostalVoteSignatureDocument, variables, options);
export const UpsertPostalVoteDraftDocument = `
    mutation UpsertPostalVoteDraft($coOwnerAccountId: ID!, $generalAssemblyId: ID!, $vote: ResolutionVoteInput!) {
  upsertPostalVoteDraft(
    coOwnerAccountId: $coOwnerAccountId
    generalAssemblyId: $generalAssemblyId
    vote: $vote
  ) {
    id
    coOwnerAccountId
    generalAssemblyId
    votes {
      id
      status
      resolutionId
      candidate
      isSecondVote
    }
  }
}
    `;
export const useUpsertPostalVoteDraftMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.UpsertPostalVoteDraftMutation, TError, Types.UpsertPostalVoteDraftMutationVariables, TContext>) =>
    useMutation<Types.UpsertPostalVoteDraftMutation, TError, Types.UpsertPostalVoteDraftMutationVariables, TContext>(
      ['UpsertPostalVoteDraft'],
      (variables?: Types.UpsertPostalVoteDraftMutationVariables) => fetcher<Types.UpsertPostalVoteDraftMutation, Types.UpsertPostalVoteDraftMutationVariables>(UpsertPostalVoteDraftDocument, variables)(),
      options
    );
useUpsertPostalVoteDraftMutation.fetcher = (variables: Types.UpsertPostalVoteDraftMutationVariables, options?: RequestInit['headers']) => fetcher<Types.UpsertPostalVoteDraftMutation, Types.UpsertPostalVoteDraftMutationVariables>(UpsertPostalVoteDraftDocument, variables, options);
export const CreateExternalEInvoiceRoutingAddressDocument = `
    mutation createExternalEInvoiceRoutingAddress($input: CreateExternalEInvoiceRoutingAddressInput!) {
  createExternalEInvoiceRoutingAddress(input: $input) {
    id
  }
}
    `;
export const useCreateExternalEInvoiceRoutingAddressMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.CreateExternalEInvoiceRoutingAddressMutation, TError, Types.CreateExternalEInvoiceRoutingAddressMutationVariables, TContext>) =>
    useMutation<Types.CreateExternalEInvoiceRoutingAddressMutation, TError, Types.CreateExternalEInvoiceRoutingAddressMutationVariables, TContext>(
      ['createExternalEInvoiceRoutingAddress'],
      (variables?: Types.CreateExternalEInvoiceRoutingAddressMutationVariables) => fetcher<Types.CreateExternalEInvoiceRoutingAddressMutation, Types.CreateExternalEInvoiceRoutingAddressMutationVariables>(CreateExternalEInvoiceRoutingAddressDocument, variables)(),
      options
    );
useCreateExternalEInvoiceRoutingAddressMutation.fetcher = (variables: Types.CreateExternalEInvoiceRoutingAddressMutationVariables, options?: RequestInit['headers']) => fetcher<Types.CreateExternalEInvoiceRoutingAddressMutation, Types.CreateExternalEInvoiceRoutingAddressMutationVariables>(CreateExternalEInvoiceRoutingAddressDocument, variables, options);
export const GetProfileBillingCustomerTaxationDocument = `
    query getProfileBillingCustomerTaxation($id: ID!) {
  account(id: $id) {
    customer {
      id
      taxation {
        isUniqueVatEntity
        numberVATIntracommunautaire
        shareCapitalAmount {
          currency
          value
        }
        vatSubjectionStatus
        vatDeclarationFrequency
        siren
        siret
        uniqueVatEntityNumber
      }
    }
  }
}
    `;
export const useGetProfileBillingCustomerTaxationQuery = <
      TData = Types.GetProfileBillingCustomerTaxationQuery,
      TError = ServerError
    >(
      variables: Types.GetProfileBillingCustomerTaxationQueryVariables,
      options?: UseQueryOptions<Types.GetProfileBillingCustomerTaxationQuery, TError, TData>
    ) =>
    useQuery<Types.GetProfileBillingCustomerTaxationQuery, TError, TData>(
      ['getProfileBillingCustomerTaxation', variables],
      fetcher<Types.GetProfileBillingCustomerTaxationQuery, Types.GetProfileBillingCustomerTaxationQueryVariables>(GetProfileBillingCustomerTaxationDocument, variables),
      options
    );

useGetProfileBillingCustomerTaxationQuery.getKey = (variables: Types.GetProfileBillingCustomerTaxationQueryVariables) => ['getProfileBillingCustomerTaxation', variables];
;

export const useInfiniteGetProfileBillingCustomerTaxationQuery = <
      TData = Types.GetProfileBillingCustomerTaxationQuery,
      TError = ServerError
    >(
      variables: Types.GetProfileBillingCustomerTaxationQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetProfileBillingCustomerTaxationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetProfileBillingCustomerTaxationQuery, TError, TData>(
      ['getProfileBillingCustomerTaxation.infinite', variables],
      (metaData) => fetcher<Types.GetProfileBillingCustomerTaxationQuery, Types.GetProfileBillingCustomerTaxationQueryVariables>(GetProfileBillingCustomerTaxationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetProfileBillingCustomerTaxationQuery.getKey = (variables: Types.GetProfileBillingCustomerTaxationQueryVariables) => ['getProfileBillingCustomerTaxation.infinite', variables];
;

useGetProfileBillingCustomerTaxationQuery.fetcher = (variables: Types.GetProfileBillingCustomerTaxationQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetProfileBillingCustomerTaxationQuery, Types.GetProfileBillingCustomerTaxationQueryVariables>(GetProfileBillingCustomerTaxationDocument, variables, options);
export const GetProfileBillingEInvoiceRoutingAddressesDocument = `
    query getProfileBillingEInvoiceRoutingAddresses($filters: EInvoiceRoutingAddressesFiltersInput) {
  eInvoiceRoutingAddresses(filters: $filters) {
    edges {
      node {
        id
        addressSuffix
        siren
        value
      }
    }
  }
}
    `;
export const useGetProfileBillingEInvoiceRoutingAddressesQuery = <
      TData = Types.GetProfileBillingEInvoiceRoutingAddressesQuery,
      TError = ServerError
    >(
      variables?: Types.GetProfileBillingEInvoiceRoutingAddressesQueryVariables,
      options?: UseQueryOptions<Types.GetProfileBillingEInvoiceRoutingAddressesQuery, TError, TData>
    ) =>
    useQuery<Types.GetProfileBillingEInvoiceRoutingAddressesQuery, TError, TData>(
      variables === undefined ? ['getProfileBillingEInvoiceRoutingAddresses'] : ['getProfileBillingEInvoiceRoutingAddresses', variables],
      fetcher<Types.GetProfileBillingEInvoiceRoutingAddressesQuery, Types.GetProfileBillingEInvoiceRoutingAddressesQueryVariables>(GetProfileBillingEInvoiceRoutingAddressesDocument, variables),
      options
    );

useGetProfileBillingEInvoiceRoutingAddressesQuery.getKey = (variables?: Types.GetProfileBillingEInvoiceRoutingAddressesQueryVariables) => variables === undefined ? ['getProfileBillingEInvoiceRoutingAddresses'] : ['getProfileBillingEInvoiceRoutingAddresses', variables];
;

export const useInfiniteGetProfileBillingEInvoiceRoutingAddressesQuery = <
      TData = Types.GetProfileBillingEInvoiceRoutingAddressesQuery,
      TError = ServerError
    >(
      variables?: Types.GetProfileBillingEInvoiceRoutingAddressesQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetProfileBillingEInvoiceRoutingAddressesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetProfileBillingEInvoiceRoutingAddressesQuery, TError, TData>(
      variables === undefined ? ['getProfileBillingEInvoiceRoutingAddresses.infinite'] : ['getProfileBillingEInvoiceRoutingAddresses.infinite', variables],
      (metaData) => fetcher<Types.GetProfileBillingEInvoiceRoutingAddressesQuery, Types.GetProfileBillingEInvoiceRoutingAddressesQueryVariables>(GetProfileBillingEInvoiceRoutingAddressesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetProfileBillingEInvoiceRoutingAddressesQuery.getKey = (variables?: Types.GetProfileBillingEInvoiceRoutingAddressesQueryVariables) => variables === undefined ? ['getProfileBillingEInvoiceRoutingAddresses.infinite'] : ['getProfileBillingEInvoiceRoutingAddresses.infinite', variables];
;

useGetProfileBillingEInvoiceRoutingAddressesQuery.fetcher = (variables?: Types.GetProfileBillingEInvoiceRoutingAddressesQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetProfileBillingEInvoiceRoutingAddressesQuery, Types.GetProfileBillingEInvoiceRoutingAddressesQueryVariables>(GetProfileBillingEInvoiceRoutingAddressesDocument, variables, options);
export const RemoveEInvoiceRoutingAddressAssignmentsDocument = `
    mutation removeEInvoiceRoutingAddressAssignments($input: RemoveEInvoiceRoutingAddressAssignmentsInput!) {
  removeEInvoiceRoutingAddressAssignments(input: $input) {
    workflowId
  }
}
    `;
export const useRemoveEInvoiceRoutingAddressAssignmentsMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.RemoveEInvoiceRoutingAddressAssignmentsMutation, TError, Types.RemoveEInvoiceRoutingAddressAssignmentsMutationVariables, TContext>) =>
    useMutation<Types.RemoveEInvoiceRoutingAddressAssignmentsMutation, TError, Types.RemoveEInvoiceRoutingAddressAssignmentsMutationVariables, TContext>(
      ['removeEInvoiceRoutingAddressAssignments'],
      (variables?: Types.RemoveEInvoiceRoutingAddressAssignmentsMutationVariables) => fetcher<Types.RemoveEInvoiceRoutingAddressAssignmentsMutation, Types.RemoveEInvoiceRoutingAddressAssignmentsMutationVariables>(RemoveEInvoiceRoutingAddressAssignmentsDocument, variables)(),
      options
    );
useRemoveEInvoiceRoutingAddressAssignmentsMutation.fetcher = (variables: Types.RemoveEInvoiceRoutingAddressAssignmentsMutationVariables, options?: RequestInit['headers']) => fetcher<Types.RemoveEInvoiceRoutingAddressAssignmentsMutation, Types.RemoveEInvoiceRoutingAddressAssignmentsMutationVariables>(RemoveEInvoiceRoutingAddressAssignmentsDocument, variables, options);
export const UpdateCustomerTaxationDocument = `
    mutation updateCustomerTaxation($customerId: ID!, $taxation: UpdateCustomerTaxationInput!) {
  updateCustomerTaxation(customerId: $customerId, taxation: $taxation)
}
    `;
export const useUpdateCustomerTaxationMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.UpdateCustomerTaxationMutation, TError, Types.UpdateCustomerTaxationMutationVariables, TContext>) =>
    useMutation<Types.UpdateCustomerTaxationMutation, TError, Types.UpdateCustomerTaxationMutationVariables, TContext>(
      ['updateCustomerTaxation'],
      (variables?: Types.UpdateCustomerTaxationMutationVariables) => fetcher<Types.UpdateCustomerTaxationMutation, Types.UpdateCustomerTaxationMutationVariables>(UpdateCustomerTaxationDocument, variables)(),
      options
    );
useUpdateCustomerTaxationMutation.fetcher = (variables: Types.UpdateCustomerTaxationMutationVariables, options?: RequestInit['headers']) => fetcher<Types.UpdateCustomerTaxationMutation, Types.UpdateCustomerTaxationMutationVariables>(UpdateCustomerTaxationDocument, variables, options);
export const GetMyPushInfosDocument = `
    query GetMyPushInfos($accountId: ID!, $customerId: ID, $cursor: CursorInput) {
  pushInfos(accountId: $accountId, customerId: $customerId, cursor: $cursor) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...PushInfoFields
      }
    }
  }
}
    ${PushInfoFieldsFragmentDoc}`;
export const useGetMyPushInfosQuery = <
      TData = Types.GetMyPushInfosQuery,
      TError = ServerError
    >(
      variables: Types.GetMyPushInfosQueryVariables,
      options?: UseQueryOptions<Types.GetMyPushInfosQuery, TError, TData>
    ) =>
    useQuery<Types.GetMyPushInfosQuery, TError, TData>(
      ['GetMyPushInfos', variables],
      fetcher<Types.GetMyPushInfosQuery, Types.GetMyPushInfosQueryVariables>(GetMyPushInfosDocument, variables),
      options
    );

useGetMyPushInfosQuery.getKey = (variables: Types.GetMyPushInfosQueryVariables) => ['GetMyPushInfos', variables];
;

export const useInfiniteGetMyPushInfosQuery = <
      TData = Types.GetMyPushInfosQuery,
      TError = ServerError
    >(
      variables: Types.GetMyPushInfosQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetMyPushInfosQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetMyPushInfosQuery, TError, TData>(
      ['GetMyPushInfos.infinite', variables],
      (metaData) => fetcher<Types.GetMyPushInfosQuery, Types.GetMyPushInfosQueryVariables>(GetMyPushInfosDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetMyPushInfosQuery.getKey = (variables: Types.GetMyPushInfosQueryVariables) => ['GetMyPushInfos.infinite', variables];
;

useGetMyPushInfosQuery.fetcher = (variables: Types.GetMyPushInfosQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetMyPushInfosQuery, Types.GetMyPushInfosQueryVariables>(GetMyPushInfosDocument, variables, options);
export const GetMyPushInfosUnreadCountDocument = `
    query GetMyPushInfosUnreadCount($accountId: ID!, $customerId: ID) {
  pushInfosUnreadCount(accountId: $accountId, customerId: $customerId)
}
    `;
export const useGetMyPushInfosUnreadCountQuery = <
      TData = Types.GetMyPushInfosUnreadCountQuery,
      TError = ServerError
    >(
      variables: Types.GetMyPushInfosUnreadCountQueryVariables,
      options?: UseQueryOptions<Types.GetMyPushInfosUnreadCountQuery, TError, TData>
    ) =>
    useQuery<Types.GetMyPushInfosUnreadCountQuery, TError, TData>(
      ['GetMyPushInfosUnreadCount', variables],
      fetcher<Types.GetMyPushInfosUnreadCountQuery, Types.GetMyPushInfosUnreadCountQueryVariables>(GetMyPushInfosUnreadCountDocument, variables),
      options
    );

useGetMyPushInfosUnreadCountQuery.getKey = (variables: Types.GetMyPushInfosUnreadCountQueryVariables) => ['GetMyPushInfosUnreadCount', variables];
;

export const useInfiniteGetMyPushInfosUnreadCountQuery = <
      TData = Types.GetMyPushInfosUnreadCountQuery,
      TError = ServerError
    >(
      variables: Types.GetMyPushInfosUnreadCountQueryVariables,
      options?: UseInfiniteQueryOptions<Types.GetMyPushInfosUnreadCountQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<Types.GetMyPushInfosUnreadCountQuery, TError, TData>(
      ['GetMyPushInfosUnreadCount.infinite', variables],
      (metaData) => fetcher<Types.GetMyPushInfosUnreadCountQuery, Types.GetMyPushInfosUnreadCountQueryVariables>(GetMyPushInfosUnreadCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetMyPushInfosUnreadCountQuery.getKey = (variables: Types.GetMyPushInfosUnreadCountQueryVariables) => ['GetMyPushInfosUnreadCount.infinite', variables];
;

useGetMyPushInfosUnreadCountQuery.fetcher = (variables: Types.GetMyPushInfosUnreadCountQueryVariables, options?: RequestInit['headers']) => fetcher<Types.GetMyPushInfosUnreadCountQuery, Types.GetMyPushInfosUnreadCountQueryVariables>(GetMyPushInfosUnreadCountDocument, variables, options);
export const MarkPushInfoAsReadDocument = `
    mutation MarkPushInfoAsRead($accountId: ID!, $customerId: ID, $pushInfoMessageId: ID!, $quality: PushInfoCustomerQuality!) {
  markPushInfoAsRead(
    accountId: $accountId
    customerId: $customerId
    pushInfoMessageId: $pushInfoMessageId
    quality: $quality
  ) {
    __typename
    ... on MutationMarkPushInfoAsReadSuccess {
      data {
        ...PushInfoFields
      }
    }
    ... on PushInfoNotAccessibleError {
      message
    }
  }
}
    ${PushInfoFieldsFragmentDoc}`;
export const useMarkPushInfoAsReadMutation = <
      TError = ServerError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.MarkPushInfoAsReadMutation, TError, Types.MarkPushInfoAsReadMutationVariables, TContext>) =>
    useMutation<Types.MarkPushInfoAsReadMutation, TError, Types.MarkPushInfoAsReadMutationVariables, TContext>(
      ['MarkPushInfoAsRead'],
      (variables?: Types.MarkPushInfoAsReadMutationVariables) => fetcher<Types.MarkPushInfoAsReadMutation, Types.MarkPushInfoAsReadMutationVariables>(MarkPushInfoAsReadDocument, variables)(),
      options
    );
useMarkPushInfoAsReadMutation.fetcher = (variables: Types.MarkPushInfoAsReadMutationVariables, options?: RequestInit['headers']) => fetcher<Types.MarkPushInfoAsReadMutation, Types.MarkPushInfoAsReadMutationVariables>(MarkPushInfoAsReadDocument, variables, options);